module.exports = __webpack_public_path__ + "static/media/Event-11.0778ec6c.svg";